import { forwardRef, useEffect, useMemo } from "react";
import { convertDate } from "helpers";
import { useParams } from "react-router-dom";
import { getOrganizationEmployees } from "../../toolkit/employees/employees.thunks";
import { useAppDispatch, useAppSelector } from "../../toolkit/hooks";
import { StaffListItem } from "../StaffListItem/StaffListItem";
import "./StaffList.styles.sass";

interface StaffListProps {
	archive: boolean;
	select: boolean;
	outline: (id: number) => string;
	read: boolean;
}

export const StaffList = forwardRef<HTMLTableSectionElement | null, StaffListProps>(
	({ archive, outline, select, read }, ref) => {
		const dispatch = useAppDispatch();
		const employeesList = useAppSelector((state) => state.employess.employeesList);
		const { organizationId } = useParams();

		const employeesListWithGoodDate = useMemo(() => {
			return employeesList.map((employee) => ({
				...employee,
				...(employee.employmentDate && {
					employmentDate: convertDate(employee.employmentDate),
				}),
				...(employee.dismissalDate && {
					dismissalDate: convertDate(employee.dismissalDate),
				}),
			}));
		}, [employeesList]);

		useEffect(() => {
			if (!employeesList.length && organizationId) dispatch(getOrganizationEmployees(+organizationId));
			//eslint-disable-next-line
		}, []);

		return (
			<tbody data-comment-false={true} ref={ref} className="staff-table-body">
				{employeesListWithGoodDate.map((employee) => (
					<StaffListItem
						read={read}
						outline={outline}
						employee={employee}
						archive={archive}
						select={select}
						key={employee.id}
					/>
				))}
			</tbody>
		);
	},
);
